export const AddPatient = "/patient_manager/add_patient";
export const GetAllPatient = "/patient_manager/all_patients_pagination/";
export const PatientSearchWithPagination = "/patient_manager/search";
export const GetMetric = "/patient_manager/metrics";
export const GetMamoMetrics = "/patient_manager/mamo_metrics";
export const DeletePatient = "/patient_manager/delete_patient";
export const GetPatientById = "/patient_manager/search_patientUUID";
export const GetPatientMetaData = "/dicom_manager2/patient_meta";
export const GetPatientVitalSigns = "/patient360/patient_vital_signs";
export const GetPatientVitalSigns2 = "/patient360-2/vital-signs";
export const GetPatientDiagnostic = "/patient360-2/diagnosticReport";
export const GetPatientDocumentList = "/patient360-2/document-list";
export const GetPatientDocumentXML = "/patient360-2/document";
export const GetPatientStudyMeta = "/dicom_manager2/study_meta";
export const SearchPatients = "/patient_manager/search";
export const SearchInboundPatients = "/inbound_manager/search_patient";
export const UpdatePatient = "/patient_manager/update_patient";
export const RenderDICOM = "/dicom_manager2/render";
export const RenderDICOM2 =
  "https://healthcare.googleapis.com/v1/projects/nexusmd-prod/locations/us/datasets/dicom.nexus-md.factstore/dicomStores/production_phi/dicomWeb/studies/";
export const UpdatePatientStatus = "/mammo_manager/status_update";
export const GetAllSites = "/get_all_sites";
export const GetAllClients = "/client_manager/all_clients";
export const GetGroups = "/group_manager/get_groups";
export const GetSharedGroups = "/share_manager/get_shared_groups";
export const UnsharePatientWithGroup =
  "/share_manager/unshare_patient_with_group";
export const ShareWithGroup = "/share_manager/share_patient_with_group";
export const ShareWithEmail = "/share_manager/share_patient_by_email";
export const GetLocation = "/pacsLocations/user/get_location";
export const GetClientLocation = "/pacsLocations/client/get_location";
export const DcmSend = "/nexusLink/dcmsend_patient";
export const GetListFiles = "/file_manager/listfiles";
export const Downloadfile = "/file_manager/downloadfile";
export const SendEfax = "/fax2/send_efax";
export const GetEfaxStatus = "/fax2/fax_status";
export const GetPatientDetails = "/patient_manager/patient_details";
export const GetStudyLogs = "/dicom_manager2/study_logs";
export const ShareStudy = "/share_manager/share_study";
export const GetLink = "/share_manager/share_study_url";
export const DcmsendStudy = "/nexusLink/dcmsend_study";
export const GetAllProviders = "/provider_manager/all_providers";
export const GetPatientStatusTimeline =
  "patient_manager/patient_status_timeline";
